import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { fetchAddress, selectAddress } from "store/vino/addressSlice";
import AddressListItem from "./AddressListItem";

const Address = () => {
	const dispatch = useDispatch();
	const address = useSelector(selectAddress);

	useEffect(() => {
		dispatch(fetchAddress());
	}, [dispatch]);

	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};

	return (
		<motion.div
			variants={container}
			initial="hidden"
			animate="show"
			className="flex flex-wrap px-4"
		>
			{address.map((address, index) => (
				<motion.div
					variants={item}
					key={index}
					className="widget flex w-full sm:w-1/3 p-8"
				>
					<AddressListItem address={address} />
				</motion.div>
			))}
		</motion.div>
	);
};

export default Address;
